/*eslint-disable*/
import React from 'react';
import { Flex, Link, Text, useColorModeValue } from '@chakra-ui/react';
import { UNITIX_SUPPORT_URL } from 'constants';

export default function Footer() {
  const textColor = useColorModeValue('gray.400', 'white');
  const linkHover = useColorModeValue('brand.500', 'brand.300');
  const year = new Date().getFullYear();

  return (
    <Flex
      zIndex="3"
      flexDirection={{ base: 'column', xl: 'row' }}
      alignItems={{ base: 'center', xl: 'start' }}
      justifyContent="space-between"
      px={{ base: '30px', md: '50px' }}
      pb="30px"
    >
      <Text
        color={textColor}
        textAlign={{ base: 'center', xl: 'start' }}
        mb={{ base: '20px', xl: '0px' }}
        fontSize="sm"
      >
        &copy; {year} NIMSI Clinic · Разработано в{' '}
        <Link
          href={UNITIX_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          fontWeight="700"
          color={textColor}
          _hover={{ color: linkHover, textDecoration: 'underline' }}
        >
          UnitiX
        </Link>
      </Text>
    </Flex>
  );
}
